import { render, staticRenderFns } from "./AnnuityDetailStatusContentModalForm.vue?vue&type=template&id=4980f5ae&"
import script from "./AnnuityDetailStatusContentModalForm.vue?vue&type=script&lang=js&"
export * from "./AnnuityDetailStatusContentModalForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnuityDetailStatusContentModalForm.vue?vue&type=style&index=0&id=4980f5ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports